import { UPDATE_FINAL_FORM_VALUES, CLEAR_FINAL_FORM_VALUES, } from '../actions/FinalFormActions';
const INITIAL_STATE = {
    form: {},
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { payload, type }) => {
    switch (type) {
        // フォームの値を更新
        case UPDATE_FINAL_FORM_VALUES: {
            return Object.assign(Object.assign({}, state), { form: Object.assign(Object.assign({}, state.form), { [payload.form]: payload.formValues }) });
        }
        // フォームの値をクリア
        case CLEAR_FINAL_FORM_VALUES: {
            return Object.assign(Object.assign({}, state), { form: Object.assign(Object.assign({}, state.form), { [payload.form]: undefined }) });
        }
        default: {
            return state;
        }
    }
};
